export { VideoComponent } from "./video-component";
export type {
  VideoComponentProps,
  VideoComponentOptions,
} from "./video-component";
